import Auth from './auth'

import './middleware'

// Active schemes
import scheme_003d9a64 from './schemes/local.js'

export default function (ctx, inject) {
  // Options
  const options = {"resetOnError":false,"scopeKey":"scope","rewriteRedirects":true,"fullPathRedirect":false,"watchLoggedIn":true,"redirect":{"login":"/login","logout":"/login","home":"/","callback":"/login"},"vuex":{"namespace":"auth"},"cookie":{"prefix":"ecm.auth.","options":{"path":"/"}},"localStorage":{"prefix":"auth."},"token":{"prefix":"token."},"refresh_token":{"prefix":"_refresh_token."},"defaultStrategy":"local"}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new scheme_003d9a64($auth, {"endpoints":{"login":{"url":"/auth/signInAsAdmin","method":"post","propertyName":"data.token"},"logout":{"url":"/auth/logout","method":"post"},"user":{"url":"/users/me","method":"get","propertyName":"data"}},"tokenRequired":true,"tokenType":"bearer","_name":"local"}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      console.error('[ERROR] [AUTH]', error)
    }
  })
}
